import AdminModal from './AdminModal';

export default function UnsavedChangesDialog({
  open,
  title = 'Unsaved changes',
  message,
  saveLabel = 'Save changes',
  discardLabel = 'Close without saving',
  stayLabel = 'Keep editing',
  onSave,
  onDiscard,
  onStay,
}) {
  return (
    <AdminModal
      open={open}
      onClose={onStay}
      title={title}
      size="sm"
      footer={
        <>
          <button type="button" className="admin-btn admin-btn--ghost" onClick={onStay}>
            {stayLabel}
          </button>
          <button type="button" className="admin-btn admin-btn--ghost" onClick={onDiscard}>
            {discardLabel}
          </button>
          {onSave ? (
            <button type="button" className="admin-btn admin-btn--primary" onClick={onSave}>
              {saveLabel}
            </button>
          ) : null}
        </>
      }
    >
      <p className="admin-modal__message">{message}</p>
    </AdminModal>
  );
}
